import { render, staticRenderFns } from "./ClusterDetails.vue?vue&type=template&id=9438d434&"
import script from "./ClusterDetails.vue?vue&type=script&lang=ts&"
export * from "./ClusterDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports